"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreedingStatus = void 0;
var BreedingStatus;
(function (BreedingStatus) {
    BreedingStatus["FailedNameExisting"] = "failed_name_existing";
    BreedingStatus["FailedPgxNotEnough"] = "failed_pgx_not_enough";
    BreedingStatus["FailedVisNotEnough"] = "failed_vis_not_enough";
    BreedingStatus["FailedMissingBreedingVersion"] = "failed_missing_breeding_version";
    BreedingStatus["FailedValentineTicketInvalidOwner"] = "failed_valentine_ticket_invalid_owner";
    BreedingStatus["FailedValentineTicketRegister"] = "failed_valentine_ticket_register";
    BreedingStatus["Success"] = "success";
})(BreedingStatus = exports.BreedingStatus || (exports.BreedingStatus = {}));
